import { createApp, type Plugin } from "vue";
import App from "@/App.vue";
import i18n from "@/i18n";
import "pusher-js/with-encryption";
import VueTippy from "vue-tippy";
import "tippy.js/dist/tippy.css";
import * as Sentry from "@sentry/vue";
import AppConfig from "@/config";
import last from "lodash/last";
import tooltipable from "@/directives/tooltipable";
import { useAnalyticsState } from "./composables/state/analyticsState";

/* style imports */
import "@/tailwind.css";
import "@fontsource/inter/latin.css";
/* end style imports */

export const appPlugins = [
  [i18n],
  [VueTippy, { component: "tooltip", directive: "tooltip", defaultProps: { theme: "lendflow" } }],
];

const app = createApp(App);

const environment = last(AppConfig.apiBaseUrl?.split("://")) ?? "unknown";
Sentry.init({
  app,
  dsn: AppConfig.sentryDsn,
  integrations: [Sentry.browserTracingIntegration()],
  environment,
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [AppConfig.apiBaseUrl ?? "localhost", /^\//],
});

appPlugins.forEach(([plugin, options]) => app.use(plugin as Plugin, options));
app.directive("tooltipable", tooltipable);

app.mount("#app");

useAnalyticsState();
